import React from 'react';
import RedditPixel from 'react-reddit-pixel';
import { useParams } from 'react-router-dom';

import EventPageContextProvider from 'app/fan/context/EventPage';

import EventPageLayout from './EventPageLayout';

const Event = () => {
  const { eventId } = useParams();
  RedditPixel.track('ViewContent');

  return (
    <EventPageContextProvider eventId={eventId}>
      <EventPageLayout />
    </EventPageContextProvider>
  );
};

export default Event;
